export default __webpack_public_path__ + "static/media/IMG_2178cropped.9fe9ea0a.jpeg";